import React from 'react';
import * as XLSX from 'xlsx';
import styles from './SampleCsv.module.css';
import { FaFileExcel } from 'react-icons/fa';
import { HiOutlineDownload } from 'react-icons/hi';
const DownloadButton = ({ campaignType, countryCode }) => {
  // Sample data for both campaign types
  const sampleData =
    campaignType === "3"
      ? [
        ['mobile', 'name', 'age', 'country'],
        ['1234567890', 'John Doe', '30', 'USA'],
        ['1234567891', 'Jane Smith', '25', 'UK'],
        ['1234567892', 'Sara Lee', '28', 'Canada']
      ]
      : [
        ["Mobile"],
        ["1234567890"],
        ['1234567891'],
        ['1234567892'],
      ];

  // Function to handle file download
  const downloadFile = () => {
    if (campaignType === "3") {
      // Generate Excel file
      const worksheet = XLSX.utils.aoa_to_sheet(sampleData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Data");

      // Export to Excel
      XLSX.writeFile(workbook, "sample.xlsx");
    } else {
      // Generate CSV file
      const csvContent = sampleData.map(row => row.join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      // Trigger download
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'sample.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className={styles.downloadWrapper}>
      <div className={styles.button} onClick={downloadFile}>
        <FaFileExcel className={styles.icon} />
        <span>Download Sample {campaignType === "3" ? "Excel" : "CSV"}</span>
        <HiOutlineDownload className={styles.icon} />
      </div>

      <div className={styles.note}>
        <h4 className={styles.noteHeading}>Instructions</h4>
        <ul>
          <li>
            The first column must have mobile numbers{" "}
            {countryCode === 99999 ? (
              <span className={styles.withCode}>with country code</span>
            ) : (
              <span className={styles.withoutCode}>without country code</span>
            )}
          </li>
          <li>Column headers must not contain spaces.</li>
          <li>
            The first header should be named <strong>‘mobile’</strong>.
          </li>
          <li>
            The maximum file size allowed {campaignType === "3"?<strong>20MB</strong>:<strong>50MB</strong>}.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DownloadButton;
